import { datadogRum } from "@datadog/browser-rum"

export default defineNuxtPlugin((nuxt) => {
  const { env, applicationId, clientToken } = nuxt.$config.public.datadog

  const isDev = ["dev", "development"].includes(env)

  const isProd = ["prod", "production"].includes(env)

  if (isDev || import.meta.dev) {
    return
  }

  // TODO: Integrate with CookieYes
  datadogRum.init({
    applicationId,
    clientToken,
    site: "datadoghq.eu",
    service: "kunne-frontend",
    env,
    version: nuxt.$config.public.app.version,
    sessionSampleRate: isProd ? 10 : 100,
    sessionReplaySampleRate: isProd ? 0 : 100, // I need to talk to compliance before enabling this in prod
    trackUserInteractions: !isProd, // I need to talk to compliance before enabling this in prod
    trackResources: !isProd, // I need to talk to compliance before enabling this in prod
    trackLongTasks: !isProd, // I need to talk to compliance before enabling this in prod
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [
      nuxt.$config.public.core.ecommerceApiBaseUrl,
      nuxt.$config.public.core.externalApiBaseUrl,
    ],
    startSessionReplayRecordingManually: isProd,
  })
})
